import {
  smallEmoji1,
  smallEmoji2,
  smallEmoji3,
  smallEmoji4
} from 'assets/images/CreditScore'

export const scoringText = {
  0: {
    title: 'Sin información',
    paragraph:
      'No tenés información de deudas en el Banco Central. Podés comenzar a construir tu perfil de crédito con un préstamo de Wayni.'
  },
  1: {
    title: '¡Sólido!',
    paragraph:
      'Estás al día con todas tus deudas. ¡Seguí así! Pagar en término tus deudas te va a ayudar a obtener mejores productos financieros.'
  },
  2: {
    title: 'Con atrasos moderados',
    paragraph:
      'Tenés deudas con atrasos menores a 90 días. Esto podría afectar tu capacidad de obtener préstamos. Como los atrasos no tienen mucha antigüedad podrías mejorar tu perfil crediticio rápidamente poniéndote al día.'
  },
  3: {
    title: 'Con atrasos riesgosos',
    paragraph:
      'Tenés deudas con atrasos por más de 90 días. Esto afecta la posibilidad de obtener nuevos préstamos. Podría llevar más tiempo mejorar tu perfil crediticio.'
  },
  4: {
    title: '¡Con atrasos graves!',
    paragraph:
      'Tenés deudas con atrasos por más de 180 días. Estos atrasos podrían llevarte a que las entidades reclamen tu deuda judicialmente mediante un embargo.'
  }
}

export const scoreColors = {
  0: 'bg-score-0 text-white stroke-white',
  1: 'bg-score-1 text-white stroke-white',
  2: 'bg-score-2 text-black stroke-black',
  3: 'bg-score-3 text-black stroke-black',
  4: 'bg-score-4 text-white stroke-white',
  default: 'bg-[#F8F8F6] text-black stroke-black'
}

export const scoreTextColors = {
  1: 'text-score-1',
  2: 'text-score-2-text',
  3: 'text-score-4',
  4: 'text-score-4'
}

export const scoreDebts = {
  1: 'border-b-score-debts-1 border-b-[2.5px]',
  2: 'border-b-score-debts-2 border-b-[2.5px]',
  3: 'border-b-score-debts-3 border-b-[2.5px]',
  4: 'border-b-score-debts-4 border-b-[2.5px]'
}
export const scoreQuestions = [
  {
    id: 1,
    qn: '¿Qué es una situación de deuda en BCRA?',
    ans: 'Estas situaciones son clasificaciones que cada entidad financiera hace sobre la deuda que poseas con la misma. Las entidades clasifican tus deudas según como haya sido tu comportamiento de pago y tu nivel de atraso.'
  },
  {
    id: 2,
    qn: '¿Cuáles son las situaciones de deuda posibles?',
    ans: (
      <span>
        Las situaciones se categorizan con números desde el 1 al 5. Siendo 1 el
        más positivo y el 5 el más negativo. Abajo te explicamos cada una:
        <ul>
          <li>
            Situación 1. Normal | Atraso en el pago que no supere los 31 días.
            (*)
          </li>
          <li>
            Situación 2. Riesgo bajo | Atraso en el pago de más de 31 y hasta 90
            días desde el vencimiento.
          </li>
          <li>
            Situación 3. Riesgo medio | Atraso en el pago de más de 90 y hasta
            180 días.
          </li>
          <li>
            Situación 4. Riesgo alto | Atraso en el pago de más de 180 días
            hasta un año.
          </li>
          <li>Situación 5. Irrecuperable | Atrasos superiores a un año.</li>
        </ul>
      </span>
    )
  },
  {
    id: 3,
    qn: '¿Cuáles son las referencias que agrupa a cada una de las situaciones de deuda posibles?',
    ans: (
      <ul>
        <li>
          <img className='inline-flex h-5 w-5' src={smallEmoji1} alt='' />{' '}
          Sólido: situación 1.
        </li>
        <li>
          <img className='inline-flex h-5 w-5' src={smallEmoji2} alt='' /> Con
          atrasos demorados: situación 2 y situación 3.
        </li>
        <li>
          <img className='inline-flex h-5 w-5' src={smallEmoji3} alt='' /> Con
          atrasos riesgosos: situación 4.
        </li>
        <li>
          <img className='inline-flex h-5 w-5' src={smallEmoji4} alt='' /> Con
          atrasos graves: situacion 5.
        </li>
      </ul>
    )
  },
  {
    id: 4,
    qn: '¿En qué se basan las entidades para calificarme?',
    ans: 'El proceso de evaluación crediticia difiere según cada institución. Es posible que las entidades evalúen tu capacidad de pago basándose en tu historial de pago de deudas pasadas. Es por eso que es muy importante mantener tus deudas al día y sin atrasos. De esta forma vas a acceder a más y mejores servicios financieros como préstamos personales y tarjetas de crédito.'
  },
  {
    id: 5,
    qn: '¿Cuánto tiempo se demora en excluirme de la Central de deudores luego de cancelar mi deuda?',
    ans: 'El Banco Central demora aproximadamente 1 mes en actualizar su base. Esto quiere decir que si cancelas tu deuda recién vas a poder ver ese pago impactado al mes próximo. Tené en cuenta que el Banco Central difunde tu historial crediticio de los últimos 24 meses, por lo que los registros continuarán informándose por ese período de tiempo a partir del mes en que se produjo la cancelación.'
  }
]
